function maybeStr(str) {
  if (typeof str === 'string') return str;
  return String(str);
}

function users(a, b) {
  let result = maybeStr(a.username).localeCompare(b.username);
  if (result !== 0) return result;

  result = maybeStr(a.email).localeCompare(b.email);
  if (result !== 0) return result;

  if (b.id < a.id) return 1;

  if (b.id > a.id) return -1;

  return 0;
}

function carriersAndDrivers(a, b) {
  let result = maybeStr(a.name || a.contact_name).localeCompare(b.name || b.contact_name);
  if (result !== 0) return result;

  if (b.id < a.id) return 1;

  if (b.id > a.id) return -1;

  return 0;
}

function contacts(a, b) {
  let result = maybeStr(a.contact_name).localeCompare(b.contact_name);
  if (result !== 0) return result;

  if (b.id < a.id) return 1;

  if (b.id > a.id) return -1;

  return 0;
}

function shipperUsers(a, b) {
  let result = maybeStr(`${a.first_name} ${a.last_name}`).localeCompare(
    `${b.first_name} ${b.last_name}`
  );
  if (result !== 0) return result;

  if (b.id < a.id) return 1;

  if (b.id > a.id) return -1;

  return 0;
}

function vehicles(a, b) {
  if (b.plate_number < a.plate_number) return 1;

  if (b.plate_number > a.plate_number) return -1;

  if (b.id < a.id) return 1;

  if (b.id > a.id) return -1;

  return 0;
}

function sortVehiclesByPlate(a, b) {
  if (b.label < a.label) return 1;
  if (b.label > a.label) return -1;
  return 0;
}

function contractsByVehicle(a, b) {
  if (b.vehicle.plate_number < a.vehicle.plate_number) return 1;

  if (b.vehicle.plate_number > a.vehicle.plate_number) return -1;

  if (b.vehicle.id < a.vehicle.id) return 1;

  if (b.vehicle.id > a.vehicle.id) return -1;

  return 0;
}

const vehicleSizes = {
  van: 1,
  box_van: 2,
  rigid_truck: 3,
  semi_trailer: 4,
  full_trailer: 5,
  tractor_unit: 998,
  no_type: 999,
};

function vehiclesBySize(a, b) {
  if (vehicleSizes[b.vehicle_type || 'no_type'] < vehicleSizes[a.vehicle_type || 'no_type'])
    return 1;

  if (vehicleSizes[b.vehicle_type || 'no_type'] > vehicleSizes[a.vehicle_type || 'no_type'])
    return -1;

  const a_pallets = a.max_pallets || 34;
  const b_pallets = b.max_pallets || 34;

  if (b_pallets < a_pallets) return 1;

  if (b_pallets > a_pallets) return -1;

  if (b.max_weight < a.max_weight) return 1;

  if (b.max_weight > a.max_weight) return -1;

  const a_score = (a.driver && a.driver.shipments) || 0;
  const b_score = (b.driver && b.driver.shipments) || 0;

  if (b_score < a_score) return -1;

  if (b_score > a_score) return 1;

  return vehicles(a, b);
}

function routes(a, b) {
  if (b.defined && !a.defined) return 1;

  if (!b.defined && a.defined) return -1;

  if (b.local && !a.local) return 1;

  if (!b.local && a.local) return -1;

  if (b.origin < a.origin) return 1;

  if (b.origin > a.origin) return -1;

  if (b.destination < a.destination) return 1;

  if (b.destination > a.destination) return -1;

  return 0;
}

export const usersIncreasingAlphabetical = users;
export const carriersAndDriversIncreasingAlphabetical = carriersAndDrivers;
export const contactsIncreasingAlphabetical = contacts;
export const shipperUsersIncreasingAlphabetical = shipperUsers;
export const vehiclesByPlate = sortVehiclesByPlate;
export const vehiclesIncreasingBySize = vehiclesBySize;
export const contractsIncreasingByVehiclePlateNumber = contractsByVehicle;
export const routesLocalFirst = routes;
